var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCommuneIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_5810)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8169 15.8824V8.82361H18.5669V15.8824H17.8169Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7529 15.8824V8.82361H20.5029V15.8824H19.7529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1914 16.2574C17.9771 16.2574 17.792 16.438 17.792 16.6668V17.255H17.042V16.6668C17.042 16.0328 17.5539 15.5074 18.1914 15.5074H20.1275C20.7651 15.5074 21.277 16.0328 21.277 16.6668V17.255H20.527V16.6668C20.527 16.438 20.3419 16.2574 20.1275 16.2574H18.1914Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.042 8.03929V7.45105H17.792V8.03929C17.792 8.26804 17.9771 8.4486 18.1914 8.4486H20.1275C20.3419 8.4486 20.527 8.26804 20.527 8.03929V7.45105H21.277V8.03929C21.277 8.67327 20.7651 9.1986 20.1275 9.1986H18.1914C17.5539 9.1986 17.042 8.67327 17.042 8.03929Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6528 15.8824V8.82361H11.4028V15.8824H10.6528Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5894 15.8824V8.82361H13.3394V15.8824H12.5894Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0279 16.2574C10.8135 16.2574 10.6284 16.438 10.6284 16.6668V17.255H9.87842V16.6668C9.87842 16.0328 10.3903 15.5074 11.0279 15.5074H12.964C13.6015 15.5074 14.1134 16.0328 14.1134 16.6668V17.255H13.3634V16.6668C13.3634 16.438 13.1783 16.2574 12.964 16.2574H11.0279Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.87842 8.03929V7.45105H10.6284V8.03929C10.6284 8.26804 10.8135 8.4486 11.0279 8.4486H12.964C13.1783 8.4486 13.3634 8.26804 13.3634 8.03929V7.45105H14.1134V8.03929C14.1134 8.67327 13.6015 9.1986 12.964 9.1986H11.0279C10.3903 9.1986 9.87842 8.67327 9.87842 8.03929Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.012207 19.6079C0.012207 19.4008 0.1801 19.2329 0.387207 19.2329H23.6128C23.8199 19.2329 23.9878 19.4008 23.9878 19.6079C23.9878 19.815 23.8199 19.9829 23.6128 19.9829H0.387207C0.1801 19.9829 0.012207 19.815 0.012207 19.6079Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.16602 18.0393C1.16602 17.8322 1.33391 17.6643 1.54102 17.6643H22.451C22.6581 17.6643 22.826 17.8322 22.826 18.0393C22.826 18.2464 22.6581 18.4143 22.451 18.4143H1.54102C1.33391 18.4143 1.16602 18.2464 1.16602 18.0393Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.48926 15.8824V8.82361H4.23926V15.8824H3.48926Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.42578 15.8824V8.82361H6.17578V15.8824H5.42578Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.86429 16.2574C3.64991 16.2574 3.46484 16.438 3.46484 16.6668V17.255H2.71484V16.6668C2.71484 16.0328 3.22677 15.5074 3.86429 15.5074H5.8004C6.43791 15.5074 6.94984 16.0328 6.94984 16.6668V17.255H6.19984V16.6668C6.19984 16.438 6.01477 16.2574 5.8004 16.2574H3.86429Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.71484 8.03929V7.45105H3.46484V8.03929C3.46484 8.26804 3.64991 8.4486 3.86429 8.4486H5.8004C6.01477 8.4486 6.19984 8.26804 6.19984 8.03929V7.45105H6.94984V8.03929C6.94984 8.67327 6.43791 9.1986 5.8004 9.1986H3.86429C3.22677 9.1986 2.71484 8.67327 2.71484 8.03929Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8364 0.0528546C11.9375 0.00533103 12.0545 0.00533103 12.1556 0.0528546L22.9978 5.15089C23.1293 5.21272 23.2132 5.34495 23.2132 5.49025V6.66672C23.2132 6.87383 23.0453 7.04172 22.8382 7.04172H1.15381C0.946702 7.04172 0.778809 6.87383 0.778809 6.66672V5.49025C0.778809 5.34495 0.862749 5.21272 0.994242 5.15089L11.8364 0.0528546ZM1.52881 5.72831V6.29172H22.4632V5.72831L11.996 0.806598L1.52881 5.72831Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_5810"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommuneIcon);
export default __webpack_public_path__ + "static/media/commune-icon.cf721006838d432d8ea875bf3934fc6d.svg";
export { ForwardRef as ReactComponent };